import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import PrintIcon  from '@mui/icons-material/Print';
import { useTranslate } from "src/locales";

interface ByzNursePrintButtonProps2 extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
  sx?: any;
  iconSize?: string;
  fontSize?: string;
  fontWeight?: number;
}

const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup }) => ({
  width: "96px",
  height: "36px",
  padding: "4px 10px",
  gap: "6px",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "22px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  border: "1px solid #2979C3",
  backgroundColor: "#63B4FF33",
  color: "#2979C3",
  "&:hover": {
    backgroundColor: "#2979C3",
    color: "#fff",
  },
}));

const ByzNursePrintButton2: React.FC<ByzNursePrintButtonProps2> = ({ 
  onClick, 
  link, 
  popup, 
  sx, 
  iconSize = "16px",
  fontSize,
  fontWeight = 400,
  ...rest 
}) => {
  const { t } = useTranslate();

  const buttonContent = (
    <>
      <PrintIcon
        style={{
          width: iconSize,
          height: iconSize,
          marginRight: "5px",
          transition: "0.2s ease-in-out",
        }}
      />
      <ByzMuiTypography
        fontWeight={fontWeight}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px",
          ...(fontSize && { fontSize }),
        }}
      >
        {t("print.print")}
      </ByzMuiTypography>
    </>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>
      <StyledButton
        popup={popup}
        sx={sx}
        {...rest}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      popup={popup}
      onClick={onClick}
      sx={sx}
      {...rest}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzNursePrintButton2;
